import ListItemIcon from './Icon/index.ts';
import ListItem, { VARIANTS } from './Item.tsx';
import ListItemText from './Text/index.ts';

const EnhancedListItem = Object.assign(ListItem, {
  Text: ListItemText,
  Icon: ListItemIcon
});

export default EnhancedListItem;
export { ListItem, ListItemText, ListItemIcon, VARIANTS };
